import React, { PropsWithChildren } from "react"
import { Heading, AccordionItem as ChakraAccordionItem, AccordionButton, Box, AccordionPanel } from "@chakra-ui/react"

import Icon from "@components/Icon/Icon"

export interface AccordionItemProps extends PropsWithChildren {
  title: string
}
const AccordionItem = ({ title, children }: AccordionItemProps) => {
  const iconStyles = (isExpanded: boolean) => {
    return {
      transform: isExpanded ? "rotate(-180deg)" : "rotate(0)",
      transition: "transform 0.2s",
      transformOrigin: "center",
    }
  }
  const iconName = title === "Reviews" ? "arrowDown" : "chevronDown"

  return (
    <ChakraAccordionItem>
      {({ isExpanded }) => (
        <>
          <Heading as="h4">
            <AccordionButton
              _hover={{ backgroundColor: "none" }}
              py={2}
              _focus={{
                outline: "none !important",
              }}
            >
              <Box flex={1} textAlign="left">
                {title}
              </Box>
              <Box __css={iconStyles(isExpanded)}>
                <Icon name={iconName} size="24px" />
              </Box>
            </AccordionButton>
          </Heading>
          <AccordionPanel paddingTop={2}>{children}</AccordionPanel>
        </>
      )}
    </ChakraAccordionItem>
  )
}

export default React.memo(AccordionItem)
